import React from 'react';
import { MUIDataTableColumnOptions } from 'mui-datatables';
import moment from 'moment';

import DateTimeSelectFilter from './components/DateTimeSelectFilter';

export const getDateTimeSelectFilter = (
  name: string,
  label: string,
  shortLabel?: string
) => {
  return {
    filterType: 'custom',
    customFilterListOptions: {
      render: (v: string) =>
        `${shortLabel || label}: ${moment(v, 'YYYY-MM-DDT00:00:00').format(
          'DD.MM.YYYY'
        )}`,
      update: (filterList, filterPos, index) => {
        filterList[index] = [];
        return filterList;
      },
    },
    filterOptions: {
      name,
      type: 'date',
      display: (filterList, onChange, index, column) => (
        <DateTimeSelectFilter
          label={label}
          name={name}
          onChange={(value) => onChange([value + 'T00:00:00'], index, column)}
        />
      ),
      logic: (prop, filterList) => {
        if (filterList.length === 0) {
          return false;
        }
        return !(
          moment(filterList[0]).startOf('day').isBefore(moment(prop)) &&
          moment(filterList[0]).endOf('day').isAfter(moment(prop))
        );
      },
    },
  } as MUIDataTableColumnOptions;
};
